import Emitter from "events";

export const CHANGE_STATE = "change_state";
export const STATE_CHANGED = "state_changed";

class StateHandler extends Emitter {
  constructor() {
    super();

    this.changeState = this.changeState.bind(this);
    this._state = {};
  }

  changeState(state) {
    const previous = { ...this._state };

    this._state = {
      ...this._state,
      ...state,
    };

    this.emit(STATE_CHANGED, this._state, previous);
  }
}

const stateHandler = new StateHandler();
export default stateHandler;

